import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { sortMethods } from '../../utils/sort.js';

export const SearchBtnContainer = styled.div`
  margin: 1.1rem auto;
  display: flex;
  justify-content: center;
  min-width: 6rem;
`;

export const logs = (logArray) => {
  logArray.sort(sortMethods.timeReverse);

  return logArray.map((value, index) => {
    let time = new Date(value.createdAt);
    return (
      <tr key={value._id}>
        <td>{moment(time).format('YYYY/MM/DD HH:mm:ss')}</td>
        <td>{value.macAddress}</td>
        <td>{value.serialNumber}</td>
        <td>{global.gConfig.statusIndex[value.prevState]}</td>
        <td>{global.gConfig.statusIndex[value.nextState]}</td>
        <td>{value.content}</td>
      </tr>
    );
  })
}
